import * as com_bluecirclesoft_website from "./com_bluecirclesoft_website";
import * as jsonInterfaceGenerator from "./jsonInterfaceGenerator";
export function sendRequest(arg0 : com_bluecirclesoft_website.InfoRequest, options : jsonInterfaceGenerator.JsonOptions<string>) : void;
export function sendRequest(arg0 : com_bluecirclesoft_website.InfoRequest, options : jsonInterfaceGenerator.JsonPromiseOptions<string>) : Promise<string>;
export function sendRequest(arg0 : com_bluecirclesoft_website.InfoRequest, options : jsonInterfaceGenerator.JsonOptions<string> | jsonInterfaceGenerator.JsonPromiseOptions<string>) : void | Promise<string> {
    const submitData = JSON.stringify(arg0);
    return jsonInterfaceGenerator.callAjax("/sendRequest/sendRequest", "POST", submitData, true, options);
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/blueCircleWebsiteParent_master/target/checkout/target/generated-typescript/com_bluecirclesoft_website_SendRequest.ts